<template>
  <VTextField
    ref="birthDateField"
    v-model="date"
    :clearable="!disabled"
    :hide-details="hideDetails"
    :label="label"
    :readonly="disabled"
    :bg-color="disabled ? 'disabled' : ''"
    :rules="[...dateFormatRules, ...rules]"
    max-length="10"
    type="date"
    :max="getCurrentDate()"
    @click:clear="$emit('update:modelValue', '')"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BDateInput",

  props: {
    modelValue: {
      type: String as () => string | null,
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array as () => ((v: string) => string | true)[],
      default: () => [],
    },
    hideDetails: {
      type: Boolean as () => boolean | undefined | "auto",
      default: false,
    },
  },

  emits: ["update:modelValue", "blur"],

  data() {
    return {
      dateFormatRules: [
        (v: string) =>
          !v ||
          !!new Date(v) ||
          !isNaN(new Date(v).getTime()) ||
          this.$t("form.dateInvalid", { format: "dd/mm/yyyy" }),
      ],
    };
  },

  computed: {
    date: {
      get() {
        return this.getDateValue(this.modelValue);
      },
      set(newValue: string | null) {
        if (newValue && !isNaN(new Date(newValue).getTime())) {
          const newDate = new Date(newValue);
          const currentYear = newDate.getFullYear();
          if (currentYear > 1900) {
            this.$emit("update:modelValue", newDate.toISOString());
          }
        } else {
          this.$emit("update:modelValue", "");
        }
      },
    },
  },

  methods: {
    getDateValue(newValue: string | null | undefined) {
      if (newValue && !isNaN(new Date(newValue).getTime())) {
        const date = new Date(newValue);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Les mois commencent à 0, donc on ajoute 1.
        const year = date.getFullYear();

        return `${year}-${month}-${day}`;
      } else {
        return "";
      }
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
});
</script>
